import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton/SolidButton';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useEditDeviationAction } from '../../../actionHooks/useEditDeviationAction';
const EditButton = (_param)=>{
    var { deviation } = _param, rest = _object_without_properties(_param, [
        "deviation"
    ]);
    const { t } = useTranslation();
    const onClick = useEditDeviationAction(deviation);
    return /*#__PURE__*/ React.createElement(SolidButton, _object_spread({
        variant: "main",
        size: "medium",
        onClick: onClick,
        biData: BiData({
            evid: 371,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        })
    }, rest), t('actionbar.stash.editDraft'));
};
EditButton.displayName = 'EditButton';
export default EditButton;
